import { ECategory, ELabel } from 'v2/resources/types/files';

export interface IMenuItem {
  id: number;
  label: string;
  value: ECategory;
}

export const optionsCategories: Array<IMenuItem> = Object.entries(
  ECategory
).map(([key, value], index) => ({
  id: index + 1,
  label: ELabel[value],
  value,
}));

export interface IFormikValues {
  file: File | null;
  title: string;
  description: string;
  category: ECategory;
}

export interface IDropZoneProps {
  isDragging: boolean;
}
